import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import routeConfiguration from '../../routeConfiguration';
import { pathByRouteName, createResourceLocatorString } from '../../util/routes';
import { apiBaseUrl } from '../../util/api';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import config from '../../config';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { GoogleLogin } from 'react-google-login';
import {
  isSignupEmailTakenError,
  isTooManyEmailVerificationRequestsError,
} from '../../util/errors';
import {
  Page,
  NamedLink,
  NamedRedirect,
  LinkTabNavHorizontal,
  IconEmailSent,
  InlineTextButton,
  SocialLoginButton,
  IconClose,
  LayoutWrapperMain,
  Modal,
  TermsOfService,
} from '../../components';
import { ConfirmSignupForm, LoginForm, SignupForm } from '../../forms';
import {
  login,
  authenticationInProgress,
  signupWithIdp,
  googleLogin,
  googleSignUp,
  corporatesignup,
} from '../../ducks/Auth.duck';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { sendVerificationEmail } from '../../ducks/user.duck';
import { manageDisableScrolling } from '../../ducks/UI.duck';

import css from './CorporateAuthenticationPage.css';
import { FacebookLogo } from './socialLoginLogos';
import { isEmpty } from 'lodash';
import CompanyLogo from '../../assets/companyLogo.svg';
import { withViewport } from 'util/contextHelpers';
const MAX_MOBILE_SCREEN_WIDTH = 550;

export class CorporateAuthenticationPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tosModalOpen: false,
      authError: Cookies.get('st-autherror')
        ? JSON.parse(Cookies.get('st-autherror').replace('j:', ''))
        : null,
      authInfo: Cookies.get('st-authinfo')
        ? JSON.parse(Cookies.get('st-authinfo').replace('j:', ''))
        : null,
    };
  }

  componentDidMount() {
    Cookies.remove('st-autherror');
  }

  render() {
    const {
      authInProgress,
      currentUser,
      intl,
      isAuthenticated,
      location,
      loginError,
      scrollingDisabled,
      signupError,
      submitLogin,
      submitSignup,
      confirmError,
      submitSingupWithIdp,
      tab,
      sendVerificationEmailInProgress,
      sendVerificationEmailError,
      onResendVerificationEmail,
      onManageDisableScrolling,
      authWithGoogle,
      authWithGoogleSignUp,
      viewport,
    } = this.props;

    const isMobileLayout = !!viewport.width ? viewport.width < MAX_MOBILE_SCREEN_WIDTH : false;
    const isConfirm = tab === 'new-confirm';
    const isLogin = tab === 'new-login';
    const locationFrom = location.state && location.state.from ? location.state.from : null;
    const authinfoFrom =
      this.state.authInfo && this.state.authInfo.from ? this.state.authInfo.from : null;
    const from = locationFrom ? locationFrom : authinfoFrom ? authinfoFrom : null;

    const user = ensureCurrentUser(currentUser);
    const currentUserLoaded = !!user.id;

    const showEmailVerification = !isLogin && currentUserLoaded && !user.attributes.emailVerified;
    let isPrivateSite = false;
    if (typeof window !== 'undefined' && !!window.sessionStorage) {
      isPrivateSite = window.sessionStorage.getItem('privateSiteUrl') ? true : false;
    }

    if (isAuthenticated && from) {
      return <Redirect to={from} />;
    } else if (isAuthenticated && currentUserLoaded && !showEmailVerification) {
      if (isPrivateSite) {
        this.props.history.push(window.sessionStorage.getItem('privateSiteUrl'));
      } else {
        if (localStorage.getItem('currentPage')) {
          this.props.history.push(localStorage.getItem('currentPage'));
        } else {
          return <NamedRedirect name="LandingPage" />;
        }
      }
    }

    const loginErrorMessage = (
      <div className={css.error}>
        {loginError ? (
          <FormattedMessage id="AuthenticationPage.loginFailedForUserNotFound" />
        ) : (
          <FormattedMessage id="AuthenticationPage.loginFailed" />
        )}
      </div>
    );

    const signupErrorMessage = (
      <div className={css.error}>
        {isSignupEmailTakenError(signupError) || signupError?.status === 409 ? (
          <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
        ) : (
          <FormattedMessage id="AuthenticationPage.signupFailed" />
        )}
      </div>
    );

    const confirmErrorMessage = confirmError ? (
      <div className={css.error}>
        {isSignupEmailTakenError(confirmError) ? (
          <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
        ) : (
          <FormattedMessage id="AuthenticationPage.signupFailed" />
        )}
      </div>
    ) : null;

    const errorMessage = (error, message) => (error ? message : null);
    const loginOrSignupError = isLogin
      ? errorMessage(loginError, loginErrorMessage)
      : errorMessage(signupError, signupErrorMessage);

    const fromState = { state: from ? { from } : null };

    const tabs = [
      {
        text: (
          <h1 className={css.tab}>
            <FormattedMessage id="AuthenticationPage.signupLinkText" />
          </h1>
        ),
        selected: !isLogin,
        linkProps: {
          name: 'NewSignupPage',
          to: fromState,
        },
      },
    ];

    const handleSubmitSignup = values => {
      const { fname, lname, email, password, ...rest } = values;
      const params = {
        email: email.trim(),
        password: password,
        firstName: fname.trim(),
        lastName: lname.trim(),
        ...rest,
      };
      const currentUserLogin = { email: email, password: password };
      submitSignup(params);
      if (!signupError) {
        localStorage.setItem('currentCorporateUserLoginData', JSON.stringify(currentUserLogin));
        this.props.history.push(
          createResourceLocatorString('CorporateThankYouPage', routeConfiguration(), {}, {})
        );
      }
    };

    const handleSubmitConfirm = values => {
      const { idpToken, email, firstName, lastName, idpId } = this.state.authInfo;
      const { email: newEmail, firstName: newFirstName, lastName: newLastName, ...rest } = values;

      const authParams = {
        ...(newEmail !== email && { email: newEmail }),
        ...(newFirstName !== firstName && { firstName: newFirstName }),
        ...(newLastName !== lastName && { lastName: newLastName }),
      };

      const protectedData = !isEmpty(rest) ? { ...rest } : null;

      submitSingupWithIdp({
        idpToken,
        idpId,
        ...authParams,
        ...(!!protectedData && { protectedData }),
      });
    };

    const authWithFacebook = () => {
      const routes = routeConfiguration();
      const baseUrl = apiBaseUrl();

      const fromParam = from ? `from=${from}` : '';

      const defaultReturn = pathByRouteName('LandingPage', routes);
      const defaultReturnParam = defaultReturn ? `&defaultReturn=${defaultReturn}` : '';

      const defaultConfirm = pathByRouteName('ConfirmPage', routes);
      const defaultConfirmParam = defaultConfirm ? `&defaultConfirm=${defaultConfirm}` : '';
      if (typeof window !== 'undefined') {
        window.location.href = `${baseUrl}/api/auth/facebook?${fromParam}${defaultReturnParam}${defaultConfirmParam}`;
      }
    };

    const resetPage = () => {
      this.props.history.push(createResourceLocatorString('HomePage', routeConfiguration(), {}));
    };

    const idp = this.state.authInfo
      ? this.state.authInfo.idpId.replace(/^./, str => str.toUpperCase())
      : null;

    const confirmForm = (
      <div className={css.content}>
        <h1 className={css.signupWithIdpTitle}>
          <FormattedMessage id="AuthenticationPage.confirmSignupWithIdpTitle" values={{ idp }} />
        </h1>

        <p className={css.confirmInfoText}>
          <FormattedMessage id="AuthenticationPage.confirmSignupInfoText" />
        </p>
        {confirmErrorMessage}
        <ConfirmSignupForm
          className={css.form}
          onSubmit={handleSubmitConfirm}
          inProgress={authInProgress}
          onOpenTermsOfService={() => this.setState({ tosModalOpen: true })}
          authInfo={this.state.authInfo}
        />
      </div>
    );

    const showSocialLogins = !!process.env.REACT_APP_FACEBOOK_APP_ID;
    const facebookButtonText = isLogin ? (
      <FormattedMessage id="AuthenticationPage.loginWithFacebook" />
    ) : (
      <FormattedMessage id="AuthenticationPage.signupWithFacebook" />
    );

    const googleButtonText = isLogin ? (
      <FormattedMessage id="AuthenticationPage.loginWithGoogle" />
    ) : (
      <FormattedMessage id="AuthenticationPage.signupWithGoogle" />
    );

    const socialLoginButtonsMaybe = showSocialLogins ? (
      <div className={css.idpButtons}>
        <div className={css.socialButtonsOr}>
          <span className={css.socialButtonsOrText}>
            <FormattedMessage id="AuthenticationPage.or" />
          </span>
        </div>

        <div className={css.socialButton}>
          <SocialLoginButton className={css.facebookLoginButton} onClick={() => authWithFacebook()}>
            <span className={css.buttonIcon}>{FacebookLogo}</span>
            {facebookButtonText}
          </SocialLoginButton>
          <GoogleLogin
            className={css.googleLoginButton}
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
            buttonText={googleButtonText}
            onSuccess={isLogin ? authWithGoogle : authWithGoogleSignUp}
            onFailure={e => console.log(e)}
            cookiePolicy={'single_host_origin'}
          />
        </div>
      </div>
    ) : null;

    const authenticationForms = (
      <div>
        {isMobileLayout && (
          <img
            className={css.voucherImgMobile}
            src="https://res.cloudinary.com/movementbuddy-pte-ltd/image/upload/v1670926845/probuddy/static/images/LoginPage/mobile_voucher_tst6qf.png"
            alt="voucher_img"
          />
        )}
        <div className={css.content}>
          <div className={css.companyLogoAndTitle} onClick={resetPage}>
            <NamedLink name="HomePage" className={css.logoLink}>
              <img src={CompanyLogo} alt="Probuddy Logo" />
            </NamedLink>
            <h2>
              <strong>Pro</strong>buddy
            </h2>
          </div>
          <LinkTabNavHorizontal className={css.tabs} tabs={tabs} />
          {loginOrSignupError}

          {isLogin ? (
            <LoginForm
              className={css.loginForm}
              onSubmit={submitLogin}
              inProgress={authInProgress}
            />
          ) : (
            <SignupForm
              className={css.signupForm}
              onSubmit={handleSubmitSignup}
              inProgress={authInProgress}
              onOpenTermsOfService={() => this.setState({ tosModalOpen: true })}
              addCity={true}
            />
          )}

          {socialLoginButtonsMaybe}
        </div>
      </div>
    );

    const formContent = isConfirm ? confirmForm : authenticationForms;

    const name = user.attributes.profile.firstName;
    const email = <span className={css.email}>{user.attributes.email}</span>;

    const resendEmailLink = (
      <InlineTextButton rootClassName={css.modalHelperLink} onClick={onResendVerificationEmail}>
        <FormattedMessage id="AuthenticationPage.resendEmailLinkText" />
      </InlineTextButton>
    );
    const fixEmailLink = (
      <NamedLink className={css.modalHelperLink} name="ContactDetailsPage">
        <FormattedMessage id="AuthenticationPage.fixEmailLinkText" />
      </NamedLink>
    );

    const resendErrorTranslationId = isTooManyEmailVerificationRequestsError(
      sendVerificationEmailError
    )
      ? 'AuthenticationPage.resendFailedTooManyRequests'
      : 'AuthenticationPage.resendFailed';
    const resendErrorMessage = sendVerificationEmailError ? (
      <p className={css.error}>
        <FormattedMessage id={resendErrorTranslationId} />
      </p>
    ) : null;

    const emailVerificationContent = (
      <div className={css.content}>
        <NamedLink className={css.verifyClose} name="ProfileAvatarPage">
          <span className={css.closeText}>
            <FormattedMessage id="AuthenticationPage.verifyEmailClose" />
          </span>
          <IconClose rootClassName={css.closeIcon} />
        </NamedLink>
        <IconEmailSent className={css.modalIcon} />
        <h1 className={css.modalTitle}>
          <FormattedMessage id="AuthenticationPage.verifyEmailTitle" values={{ name }} />
        </h1>
        <p className={css.modalMessage}>
          <FormattedMessage id="AuthenticationPage.verifyEmailText" values={{ email }} />
        </p>
        {resendErrorMessage}

        <div className={css.bottomWrapper}>
          <p className={css.modalHelperText}>
            {sendVerificationEmailInProgress ? (
              <FormattedMessage id="AuthenticationPage.sendingEmail" />
            ) : (
              <FormattedMessage id="AuthenticationPage.resendEmail" values={{ resendEmailLink }} />
            )}
          </p>
          <p className={css.modalHelperText}>
            <FormattedMessage id="AuthenticationPage.fixEmail" values={{ fixEmailLink }} />
          </p>
        </div>
      </div>
    );

    const siteTitle = config.siteTitle;
    const schemaTitle = isLogin
      ? intl.formatMessage({ id: 'AuthenticationPage.schemaTitleLogin' }, { siteTitle })
      : intl.formatMessage({ id: 'AuthenticationPage.schemaTitleSignup' }, { siteTitle });
    console.log('test');
    return (
      <Page
        title={schemaTitle}
        scrollingDisabled={scrollingDisabled}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'WebPage',
          name: schemaTitle,
        }}
      >
        <LayoutWrapperMain className={css.layoutWrapperMain}>
          <div className={css.root}>
            {showEmailVerification ? emailVerificationContent : formContent}
            <div className={css.authenticationPageImage}>
              <img
                src={
                  !isMobileLayout &&
                  'https://res.cloudinary.com/movementbuddy-pte-ltd/image/upload/v1671515270/probuddy/static/images/LoginPage/corporate_pass_ng5oij.png'
                }
                alt="Authentication Page"
              />
            </div>
          </div>
          <Modal
            id="AuthenticationPage.tos"
            isOpen={this.state.tosModalOpen}
            onClose={() => this.setState({ tosModalOpen: false })}
            onManageDisableScrolling={onManageDisableScrolling}
          >
            <div className={css.termsWrapper}>
              <h2 className={css.termsHeading}>
                <FormattedMessage id="AuthenticationPage.termsHeading" />
              </h2>
              <TermsOfService />
            </div>
          </Modal>
        </LayoutWrapperMain>
      </Page>
    );
  }
}

CorporateAuthenticationPageComponent.defaultProps = {
  currentUser: null,
  loginError: null,
  signupError: null,
  confirmError: null,
  tab: 'corporate-signup',
  sendVerificationEmailError: null,
  showSocialLoginsForTests: false,
};

const { bool, func, object, oneOf, shape } = PropTypes;

CorporateAuthenticationPageComponent.propTypes = {
  authInProgress: bool.isRequired,
  currentUser: propTypes.currentUser,
  isAuthenticated: bool.isRequired,
  loginError: propTypes.error,
  scrollingDisabled: bool.isRequired,
  signupError: propTypes.error,
  confirmError: propTypes.error,

  submitLogin: func.isRequired,
  submitSignup: func.isRequired,
  tab: oneOf(['new-login', 'corporate-signup', 'new-confirm']),

  sendVerificationEmailInProgress: bool.isRequired,
  sendVerificationEmailError: propTypes.error,
  onResendVerificationEmail: func.isRequired,
  onManageDisableScrolling: func.isRequired,

  // from withRouter
  location: shape({ state: object }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { isAuthenticated, loginError, signupError, confirmError } = state.Auth;
  const { currentUser, sendVerificationEmailInProgress, sendVerificationEmailError } = state.user;
  return {
    authInProgress: authenticationInProgress(state),
    currentUser,
    isAuthenticated,
    loginError,
    scrollingDisabled: isScrollingDisabled(state),
    signupError,
    confirmError,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
  };
};

const mapDispatchToProps = dispatch => ({
  submitLogin: ({ email, password }) => dispatch(login(email, password)),
  authWithGoogle: response => dispatch(googleLogin(response)),
  authWithGoogleSignUp: response => dispatch(googleSignUp(response)),
  submitSignup: params => dispatch(corporatesignup(params)),
  submitSingupWithIdp: params => dispatch(signupWithIdp(params)),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CorporateAuthenticationPage = compose(
  withRouter,
  withViewport,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(CorporateAuthenticationPageComponent);

export default CorporateAuthenticationPage;
